<ng-container *transloco="let t; read: 'field-alias-selector'">
  <div class="field-alias-selector__search-wrapper">
    <xi-search-box
      [hasOutline]="false"
      placeholder="Search"
      (onChangeOverride)="onFilterFields($event.detail.searchText)"
    ></xi-search-box>
  </div>
  <div class="field-alias-selector__table">
    <table
      mat-table
      [dataSource]="includedFieldsDataSource"
      class="xi-table__table"
      [formGroup]="includedFieldsFG"
    >
      <div>
        <ng-container matColumnDef="include">
          <th mat-header-cell *matHeaderCellDef></th>

          <td mat-cell *matCellDef="let field; let i = index">
            <xi-checkbox
              [formControlName]="field.fieldName"
              [matTooltip]="
                includedFieldsFG.get(field.fieldName).disabled && !this.isReadOnly
                  ? t('must-have-one-aliased-field')
                  : null
              "
              [matTooltipPosition]="'left'"
            ></xi-checkbox></td
        ></ng-container>
      </div>
      <ng-container matColumnDef="fieldName">
        <th mat-header-cell *matHeaderCellDef>
          <span>{{ t('field') }}</span>
        </th>

        <td mat-cell *matCellDef="let field">
          <label [for]="field.id">{{ field.label }}</label>
        </td></ng-container
      >

      <tr mat-header-row *matHeaderRowDef="includFieldColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; let index = index; columns: includFieldColumns"></tr>
      <tr *matNoDataRow>
        <td [attr.colspan]="includFieldColumns.length">
          <div class="field-alias-selector__no-table-data">
            <p class="field-alias-selector__no-results-text">
              {{ t('no-metadata-fields-defined') }}
            </p>
          </div>
        </td>
      </tr>
    </table>
  </div>
</ng-container>
